import { useContext } from 'react';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

//import axios from 'axios';
import { useFormPageApp } from './FormPageAppContext';

export default function FormHeaderSpecialist({ taskId, taskParams, statusDisplay }) {
  const { apiClient, apiUrlContext, authTokenContext, ConfirmationModal } =
    useFormPageApp();
  const api_url = useContext(apiUrlContext);
  const token = useContext(authTokenContext);
  const navigate = useNavigate();

  function ReturnTaskClick(id, operation) {
    const params = { operation: operation };

    apiClient
      .put(api_url + `/manage_task/` + id, params, {
        headers: {
          Authorization: token,
          //"Content-Type": "application/json",
        },
      })
      .then(
        (result) => {
          //navigate("/");
          navigate(0);
        },
        (error) => {
          console.log(error);
          alert(error.response?.data);          
        }
      );
  }

  function DeleteTaskClick(id) {
    apiClient
      .delete(api_url + `/manage_task/` + id, {
        headers: {
          Authorization: token,
          //"Content-Type": "application/json",
        },
      })
      .then(
        (result) => {
          navigate('/');
          navigate(0);
        },
        (error) => {
          console.log(error);
          alert(error.response?.data);
        }
      );
  }

  function RemoveDataFromEAS(id) {
    apiClient
      .delete(api_url + `/export_task_data/` + id, {
        headers: {
          Authorization: token,
          //"Content-Type": "application/json",
        },
      })
      .then(
        (result) => {
          console.log('Task data deleted from EAS');
          navigate('/task/' + id);
          navigate(0);
        },
        (error) => {
          console.log(error);
          alert(error.response?.data);             
        }
      );
  }

  return (
    <>
      <ConfirmationModal
        modalId="confirmTaskDeleteModal"
        headerText="Задание"
        messageText={['Вы уверены, что хотите удалить задание?']}
        confirmButtonText="Удалить"
        Action={() => DeleteTaskClick(taskId)}
        danger
      />

      <ConfirmationModal
        modalId="confirmTaskReturnToLabModal"
        headerText="Задание"
        messageText={[
          'Вы уверены, что хотите вернуть задание лаборатории для исправления данных?',
        ]}
        confirmButtonText="Вернуть задание"
        Action={() => ReturnTaskClick(taskId, 'return-task-to-lab')}
      />

      <ConfirmationModal
        modalId="confirmTaskReturnToExpertModal"
        headerText="Задание"
        messageText={[
          'Вы уверены, что хотите вернуть задание эксперту для исправления данных?',
        ]}
        confirmButtonText="Вернуть задание"
        Action={() => ReturnTaskClick(taskId, 'return-task-to-expert')}
      />

      <ConfirmationModal
        modalId="confirmTaskDataRemoveFromEAS"
        headerText="Задание"
        messageText={[
          'Вы уверены, что хотите удалить данные из промежуточной БД ИАС?',
        ]}
        confirmButtonText="Удалить данные"
        Action={() => RemoveDataFromEAS(taskId)}
        danger
      />

      <div className="row m-3">
        <div className="col-9">
          <div className="form-head p-3 d-grid gap-3 d-md-flex justify-content-between align-items-stretch">
            <div>
              <h6>
                Цикл: <b>{taskParams.form.cycle}</b>
              </h6>
              <h6>
                Представление результатов до: <b>{taskParams.deadline_date}</b>
              </h6>
              <h6>
                Результаты представлены: <b>{taskParams.completed_date}</b>
              </h6>
              <h6>Номера ОПК: {taskParams.samples}</h6>
              <h6>
                Статус: <b>{statusDisplay}</b>{' '}
              </h6>
              {taskParams.return_requested && <p className='fw-medium text-danger'>лаборатория запросила возврат задания</p>}
            </div>
            <div className="d-flex flex-column align-items-end mt-3 me-3">
              <div className="dropdown">
                <button
                  className="btn lk-button dropdown-toggle px-4"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Действия
                </button>
                <ul className="dropdown-menu">
                  {taskParams.status === 'SENT' && (
                    <>
                      <button
                        className="dropdown-item lk-menu-dropdown"
                        data-bs-toggle="modal"
                        data-bs-target="#confirmTaskReturnToLabModal"
                      >
                        Вернуть задание лаборатории
                      </button>
                      {taskParams.form?.expert_checking && (
                        <button
                          className="dropdown-item lk-menu-dropdown"
                          data-bs-toggle="modal"
                          data-bs-target="#confirmTaskReturnToExpertModal"
                        >
                          Вернуть задание эксперту
                        </button>
                      )}
                      <button
                        className="dropdown-item lk-menu-dropdown"
                        onClick={() => navigate('/export/' + String(taskParams.id))}
                      >
                        Выгрузить данные в ИАС...
                      </button>
                    </>
                  )}
                  {taskParams.status === 'EXPORTED_TO_EAS' && (
                    <>
                      <button
                        className="dropdown-item lk-menu-dropdown"
                        data-bs-toggle="modal"
                        disabled
                      >
                        Вернуть задание лаборатории
                      </button>
                      {taskParams.form?.expert_checking && (
                        <button
                          className="dropdown-item lk-menu-dropdown"
                          data-bs-toggle="modal"
                          disabled
                        >
                          Вернуть задание эксперту
                        </button>
                      )}
                      <button className="dropdown-item lk-menu-dropdown" disabled>
                        {' '}
                        Выгрузить данные в ИАС...
                      </button>
                      <button
                        className="dropdown-item lk-menu-dropdown"
                        data-bs-toggle="modal"
                        data-bs-target="#confirmTaskDataRemoveFromEAS"
                      >
                        Удалить данные из ИАС...
                      </button>
                    </>
                  )}
                  {!['SENT', 'EXPORTED_TO_EAS'].includes(taskParams.status) && (
                    <>
                      <button
                        className="dropdown-item lk-menu-dropdown"
                        data-bs-toggle="modal"
                        disabled
                      >
                        Вернуть задание лаборатории
                      </button>
                      {taskParams.form?.expert_checking && (
                        <button
                          className="dropdown-item lk-menu-dropdown"
                          data-bs-toggle="modal"
                          disabled
                        >
                          Вернуть задание эксперту
                        </button>
                      )}
                      <button className="dropdown-item lk-menu-dropdown" disabled>
                        {' '}
                        Выгрузить данные в ИАС...
                      </button>
                    </>
                  )}
                  {/**
                  <div className="dropdown-divider" />
                  <button
                    className="dropdown-item lk-menu-dropdown"
                    data-bs-toggle="modal"
                    data-bs-target="#confirmTaskDeleteModal"
                  >
                    Удалить задание
                  </button>
                   */}
                </ul>
              </div>
              <div className="mt-auto pt-2">
                <Link to={`/task/${taskId}/history`} className="small text-end d-inline-block">
                  Просмотр истории задания
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
